module.exports = __webpack_public_path__ + "static/img/アセット 24@2x.105388b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 24@2x.png
// module id = MLLg
// module chunks = 1